module.exports = __webpack_public_path__ + "static/media/dark-theme-max-RPM.5959d5a8.svg";